"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SanyoLogisticsInc = void 0;
exports.SanyoLogisticsInc = {
    id: 'sanyoLogisticsInc',
    companyName: 'Sanyo Logistics Inc.',
    transportModes: ['sea'],
    freightGate: {
        isOnboarded: true,
        realm: 'sanyoLogisticsInc',
    },
    isInternal: false,
    isActive: true,
    countries: ['JP'],
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU2FueW9Mb2dpc3RpY3NJbmMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvYWdlbnRzL2RhdGEvU2FueW9Mb2dpc3RpY3NJbmMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSxpQkFBaUIsR0FBVTtJQUNwQyxFQUFFLEVBQUUsbUJBQW1CO0lBQ3ZCLFdBQVcsRUFBRSxzQkFBc0I7SUFDbkMsY0FBYyxFQUFFLENBQUMsS0FBSyxDQUFDO0lBQ3ZCLFdBQVcsRUFBRTtRQUNULFdBQVcsRUFBRSxJQUFJO1FBQ2pCLEtBQUssRUFBRSxtQkFBbUI7S0FDN0I7SUFDRCxVQUFVLEVBQUUsS0FBSztJQUNqQixRQUFRLEVBQUUsSUFBSTtJQUNkLFNBQVMsRUFBRSxDQUFDLElBQUksQ0FBQztDQUNwQixDQUFBIn0=